class TextStripe extends HTMLElement {
  #wrapper;
  #resizeObserver;

  connectedCallback() {
    this.#wrapper = this.querySelector('.marquee__wrapper');
    if (!this.#wrapper) return;

    this.#resizeObserver = new ResizeObserver(() => this.#updateDuration());
    this.#resizeObserver.observe(this.#wrapper);

    requestAnimationFrame(() => this.#updateDuration());
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
  }

  #updateDuration() {
    if (!this.#wrapper) return;

    const wrapperWidth = this.#wrapper.offsetWidth;
    if (!wrapperWidth) return;

    const gap = parseFloat(getComputedStyle(this.#wrapper).columnGap) || 0;
    const distance = wrapperWidth / 2 + gap / 2;

    const pps = Math.max(10, Number(this.getAttribute('data-pixels-per-second')) || 50);
    const duration = Math.max(1, distance / pps);

    this.style.setProperty('--text-stripe-duration', `${duration}s`);
  }
}

if (!customElements.get('text-stripe')) {
  customElements.define('text-stripe', TextStripe);
}
